import React, { useState, useEffect } from "react";
import Logo from "../../../images/VastrakalaLogoBlack.svg";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getItems_Wishlist,
  getItems_Cart,
  get_Addresses,
  logout_Cart,
} from "../../../actions/cartAction";
import Modal from "react-bootstrap/Modal";
import { logout, loadingState, setSelectedCategory } from "../../../actions/userAction";
import "../Loader/Loader.css";

const Header = () => {
  const dispatch = useDispatch();
  const { cartItems, wishlist } = useSelector((state) => state.cart);
  const { isAuthenticated, user, selectedCategory: selectedCategoryLocal } = useSelector((state) => state.user);
  const [searchInput, setSearchInput] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [allCategories, setAllCategories] = useState([]);
  const abortController = new AbortController();
  const { signal } = abortController;
  const history = useHistory();
  const [selectedCategory, setSelectedCategoryLocal] = useState(selectedCategoryLocal);
  const [loading, setloadingState] = useState(false);
  const [menTag, setMenTag] = useState([]);
  const [womenTag, setWomenTag] = useState([]);
  const [kidsTag, setKidsTag] = useState([]);

  function updateSelectedCategory(category) {
    setSelectedCategoryLocal(category);
    dispatch(setSelectedCategory(category));
    localStorage.setItem("selectedCategory", category);
  }

  function getTagsImages() {
    fetch(`/api/banner/tags`)
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          for (let tag of data) {
            if (tag.type === "Men") {
              setMenTag(tag.name);
            } else if (tag.type === "Women") {
              setWomenTag(tag.name);
            }
            else if (tag.type === "Kids") {
              setKidsTag(tag.name);
            }
          }

        }
      });
  }

  const handleLogoutClick = () => {
    // Handle the "Logout" action
    console.log('Logout clicked');
    dispatch(logout());
    dispatch(logout_Cart());
  };


  const fetchSearchResults = async () => {
    try {
      // Replace 'YOUR_SEARCH_API_ENDPOINT' with the actual endpoint of your search API
      const response = await fetch(
        `/api/products/search?query=${searchInput}`,
        { signal }
      );
      if (response.ok) {
        const data = await response.json();
        setSearchResults(data.products);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
    }
  };

  useEffect(() => {
    dispatch(loadingState(false));

    if (window.innerWidth <= 760) {
      getTagsImages();
    }
    let timeoutId = setTimeout(() => {
      if (searchInput !== "") {
        fetchSearchResults();
      } else {
        setSearchResults([]);
      }
    }, 300);
    return () => {
      clearTimeout(timeoutId);
      abortController.abort();
    };
  }, [searchInput]);

  useEffect(() => {
    if (selectedCategory)
      localStorage.setItem("selectedCategory", selectedCategory);
    // // Initialize selectedCategory from localStorage or default to 'Women'
    // const savedCategory = localStorage.getItem("selectedCategory");
    // if (savedCategory && savedCategory !== selectedCategory) {
    //   updateSelectedCategory(savedCategory)
    // } else if (!savedCategory) {
    //   updateSelectedCategory('Women')
    // }
  }, [selectedCategory]);

  function getallCat() {
    fetch(`/api/categories/all/${selectedCategory}`)
      .then((response) => response.json())
      .then((data) => {
        setToggled([false * data.length]);
        setTimeout(() => { setAllCategories(data); }, 500);
      });
  }
  useEffect(() => {
    getallCat()
  }, [selectedCategory]);

  const [isToggled, setToggled] = useState([]);

  const handleToggle = (i) => {
    let all_toggles = [...isToggled];
    all_toggles[i] = !all_toggles[i];
    setToggled(all_toggles);
  };

  const handleClick = (url, id) => {
    setSearchInput("");
    history.push(url, { id });
  };

  useEffect(() => {
    dispatch(get_Addresses());
    dispatch(getItems_Cart(isAuthenticated));
    dispatch(getItems_Wishlist(isAuthenticated));
    getMarque();
  }, []);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [marque1, setMarque1] = useState('');
  function getMarque() {
    fetch("/api/marque")
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setMarque1(data[0].value)
        }
      });
  }

  return (
    <>
      {loading ? <div className="loading">
        <div></div>
      </div> : <></>}
      <div className="stickyTop">
        <div className="topBar">
          <div className="container">
            <div className="row">
              <marquee direction="left">
                <p>{marque1}</p>
              </marquee>
            </div>
          </div>
        </div>
        <header>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-6 col-md-3 col-lg-2">
                <div className="logoDiv">
                  <div className="menuToggle">
                    <i
                      class="fa-solid fa-bars"
                      variant="primary"
                      onClick={handleShow}
                    ></i>
                  </div>
                  <Link to="../../../../">
                    <img src={Logo} width="100%" loading="lazy" />
                  </Link>
                </div>
              </div>
              <div className="col-md-7">
                <div className="navSearch">
                  <div className="toggleCategory">
                    <button
                      className={selectedCategory === "Women" ? "active" : ""}
                      onClick={(e) => updateSelectedCategory("Women")}
                    >
                      Women
                    </button>
                    <button
                      className={selectedCategory === "Men" ? "active" : ""}
                      onClick={(e) => updateSelectedCategory("Men")}
                    >
                      Men
                    </button>
                    <button
                      className={selectedCategory === "Kids" ? "active" : ""}
                      onClick={(e) => updateSelectedCategory("Kids")}
                    >
                      Kids
                    </button>
                  </div>
                  <div className="headSearch">
                    <label htmlFor="search">
                      <i className="fa-solid fa-magnifying-glass"></i>
                    </label>
                    <input
                      type="text"
                      placeholder="Search..."
                      value={searchInput}
                      onInput={(e) => setSearchInput(e.target.value)}
                    />
                  </div>
                  <div
                    className="searchResults"
                    style={{
                      display: searchResults.length > 0 ? "block" : "none",
                    }}
                  >
                    {searchResults?.map((product) => {
                      return (
                        <div className="singleResult">
                          <a
                            onClick={() =>
                              handleClick(
                                `/singleproduct/${product.name}/p/${product.product_id}`,
                                product.product_id
                              )
                            }
                          >
                            <div className="prodData">
                              <img
                                loading="lazy"
                                src={product.image ? (process.env.REACT_APP_BASE_URL + product.image) : "../../No-Image.png"}
                                alt="Resultimg"
                              />
                              <h3 className="prdTitle">{product.name}</h3>
                            </div>
                            <div className="prdPrice">
                              <p>RS {product.selling_price}</p>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                    <div className="viewAllResult">
                      <Link to={`/search/${searchInput}`} onClick={e => { setSearchResults([]) }}>View All Result</Link>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-6 col-md-2 col-lg-3">
                <div className="rightIcons">
                  <ul>
                    <li>
                      <a href="https://wa.me/+919872407145">
                        <i className="fa-brands fa-whatsapp"></i>
                      </a>
                    </li>
                    <li className="head_myacc">
                      <Link to="../../../../UserAccount" className="User_i">
                        {isAuthenticated && <span className="signedIn"></span>}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_176_359)">
                            <path
                              d="M21.9787 20.9458C21.454 18.9762 20.3028 17.2308 18.6989 15.9729C17.0613 14.679 15.0358 13.9739 12.9487 13.971H9.03C6.94847 13.9686 4.92809 14.6746 3.30106 15.9729C1.69948 17.2234 0.542217 18.9556 -6.57141e-06 20.9139C-0.0371895 21.0427 -0.0430596 21.1785 -0.0171278 21.31C0.00880408 21.4415 0.065787 21.5649 0.149074 21.6699C0.22731 21.7736 0.328753 21.8574 0.44526 21.9147C0.561768 21.9721 0.690093 22.0013 0.819935 22C1.00938 21.9984 1.19285 21.9336 1.34135 21.8159C1.48984 21.6983 1.59489 21.5345 1.63988 21.3505C2.07409 19.7319 3.03091 18.3021 4.36158 17.2833C5.69226 16.2646 7.32222 15.7141 8.99806 15.7174H12.9167C14.5935 15.7105 16.2252 16.2596 17.5566 17.2789C18.888 18.2982 19.844 19.73 20.2749 21.3505C20.3199 21.5345 20.425 21.6983 20.5735 21.8159C20.7219 21.9336 20.9054 21.9984 21.0949 22C21.2281 22.0038 21.3604 21.9758 21.4807 21.9184C21.6011 21.861 21.7061 21.7759 21.787 21.6699C21.872 21.5718 21.9335 21.4556 21.9667 21.3301C21.9999 21.2046 22.004 21.0731 21.9787 20.9458ZM10.9893 12.3844C12.6124 12.3759 14.1659 11.7245 15.3096 10.5728C16.4532 9.42118 17.0938 7.86317 17.091 6.24011C17.0984 5.42042 16.9442 4.60731 16.6372 3.84722C16.3303 3.08714 15.8766 2.39498 15.302 1.8103C14.7485 1.23993 14.0866 0.785963 13.3551 0.475087C12.6236 0.16421 11.8374 0.00269569 11.0426 3.64401e-05C10.2218 -0.00277076 9.40863 0.15664 8.64968 0.469107C7.89074 0.781575 7.20102 1.24094 6.62017 1.8208C6.03931 2.40067 5.57877 3.0896 5.26501 3.84801C4.95125 4.60642 4.79045 5.41936 4.79186 6.24011C4.79071 7.05003 4.95224 7.85193 5.26687 8.59824C5.58149 9.34456 6.04279 10.0201 6.62342 10.5847C7.78355 11.7383 9.35334 12.3853 10.9893 12.3844ZM10.9893 1.73576C12.1812 1.73576 13.3241 2.2092 14.1669 3.05193C15.0096 3.89467 15.4831 5.03766 15.4831 6.22947C15.4831 7.42127 15.0096 8.56426 14.1669 9.407C13.3241 10.2497 12.1812 10.7232 10.9893 10.7232C10.4044 10.7204 9.82578 10.6021 9.28671 10.375C8.74764 10.1479 8.25874 9.8166 7.8481 9.40003C7.43746 8.98345 7.11318 8.48985 6.89387 7.94757C6.67456 7.40529 6.56456 6.82503 6.57018 6.24011C6.55596 5.05293 7.01325 3.90858 7.84173 3.05815C8.6702 2.20771 9.80219 1.72065 10.9893 1.70381V1.73576Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_176_359">
                              <rect width="22" height="22" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </Link>
                      {isAuthenticated && <div className="accHoverData">
                        <ul>
                          <li>
                            <span>Welcome <b>{isAuthenticated && user.first_name}</b></span>
                          </li>
                          <li>
                            <Link to="../../../../UserAccount">
                              <i className="fa-regular fa-user"></i> Account
                              Details
                            </Link>
                          </li>
                          <li>
                            <Link to={{
                              pathname: `../../../../../UserAccount`,
                              state: {
                                page: 4,
                              },
                            }}>
                              <i className="fa-solid fa-heart"></i>Wishlist
                            </Link>
                          </li>
                          <li>
                            <a onClick={() => handleLogoutClick()}>
                              <i className="fa-solid fa-power-off"></i>Logout
                            </a>
                          </li>
                        </ul>
                      </div>
                      }
                    </li>
                    <li>
                      <Link to={{
                        pathname: `../../../UserAccount`,
                        state: {
                          page: 4,
                        },
                      }} >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_176_363)">
                            <path
                              d="M7.07782 2.92145C7.88289 2.91474 8.67855 3.09489 9.40222 3.44773C10.1259 3.80057 10.7578 4.31649 11.2484 4.95491C11.3375 5.06895 11.4515 5.1612 11.5817 5.22464C11.7118 5.28808 11.8547 5.32105 11.9995 5.32105C12.1442 5.32105 12.2871 5.28808 12.4172 5.22464C12.5474 5.1612 12.6614 5.06895 12.7505 4.95491C13.2436 4.31467 13.8779 3.79704 14.604 3.44242C15.3301 3.08779 16.1283 2.90576 16.9364 2.91054C19.8087 2.91818 22.1302 5.19709 22.1236 8.00072C22.1236 11.8429 19.296 15.1985 16.9244 17.3345C15.4035 18.6917 13.7543 19.8977 12 20.9356C10.2458 19.8981 8.59654 18.6924 7.07564 17.3356C4.70182 15.1975 1.87418 11.8429 1.87418 8.00072C1.87855 5.19709 4.20545 2.92472 7.07782 2.92145ZM12.4484 22.7956C14.4986 21.6479 16.4157 20.277 18.1647 18.708C19.7042 17.3615 21.0423 15.8009 22.1378 14.0738C23.3738 12.0611 24 10.0145 24 8.00072C24 6.90981 23.7338 5.83418 23.2255 4.86109C21.4473 1.46181 17.1807 0.111269 13.6964 1.848C13.0766 2.16007 12.5052 2.56022 12 3.036C11.4937 2.56011 10.9212 2.15996 10.3004 1.848C9.30057 1.35041 8.19895 1.09163 7.08218 1.092C3.17236 1.08981 0.00218182 4.18363 0 8.00072C0 10.0145 0.626182 12.0611 1.86218 14.0727C2.95667 15.8003 4.29442 17.361 5.83418 18.7069C7.58318 20.2759 9.50028 21.6468 11.5505 22.7945C11.6884 22.8691 11.8427 22.9082 11.9995 22.9082C12.1562 22.9082 12.3105 22.8702 12.4484 22.7956Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_176_363">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="cCount">{wishlist.length}</span>
                      </Link>
                    </li>
                    <li>
                      <Link to={`../../../../Cart`}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                        >
                          <g clip-path="url(#clip0_176_367)">
                            <path
                              d="M19.8709 5.17591V5.08129H16.5118C16.3672 3.70843 15.7273 2.43528 14.712 1.50004C13.6966 0.564788 12.3753 0.0315199 10.9952 0C9.61676 0.0337873 8.29772 0.568069 7.28433 1.5031C6.27094 2.43814 5.63247 3.71001 5.4881 5.08129H2.15735L-7.05781e-05 19.4546V19.5587C-0.0179521 20.1855 0.212763 20.7939 0.641746 21.2513C1.07073 21.7086 1.66317 21.9778 2.28982 22H19.7006C20.3314 21.9778 20.9277 21.7063 21.3588 21.2452C21.7898 20.784 22.0204 20.1707 21.9999 19.5398L19.8709 5.17591ZM7.12509 5.08129C7.27436 4.15332 7.74249 3.30642 8.44887 2.68639C9.15526 2.06636 10.0557 1.71199 10.9952 1.6843C11.9363 1.70982 12.839 2.06321 13.5474 2.68343C14.2557 3.30365 14.7252 4.15176 14.8748 5.08129H7.12509ZM20.3724 19.5871C20.3725 19.7755 20.2997 19.9567 20.1691 20.0925C20.0386 20.2284 19.8605 20.3084 19.6722 20.3157H2.28982C2.10728 20.3085 1.93431 20.2322 1.80602 20.1021C1.67773 19.9721 1.60374 19.7981 1.59907 19.6155L3.49154 6.76559H18.4799L20.3724 19.5871Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_176_367">
                              <rect width="22" height="22" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <span className="cCount">{cartItems.length}</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </header>
        <div className="headerMenu">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-10">
                <div className="subMenu">
                  <ul>
                    <li>
                      <Link to={{
                        pathname: "../../../../category/Bestseller",
                        state: {
                          id: 0,
                          name: "Bestseller",
                          page: 1,
                        },
                      }} >Bestseller</Link>
                    </li>
                    {allCategories?.map((category) => (
                      <li className="menuDropDown" key={category.id}>
                        <Link
                          to={{
                            pathname: `../../../../category/${category.name}/${category.id}`,
                            state: {
                              id: category.id,
                              name: category.name,
                              page: 1,
                            },
                          }}
                        >
                          {category.name} <i className="fa-solid fa-angle-down"></i>
                        </Link>
                        <div className="megaMenu">
                          <div className="container">
                            <div className="row">
                              {category.subcategories?.map((sub_category) => (

                                sub_category.subcategories.length > 0 ?
                                  <div className="col-md-2" key={sub_category.id}>
                                    <h2 className="collTitle">{sub_category.name}</h2>
                                    <ul>
                                      {sub_category.subcategories?.map((sub_sub_category) => (
                                        <li key={sub_sub_category.id}>
                                          <Link
                                            to={{
                                              pathname: `../../../../category/${sub_sub_category.name}/${sub_sub_category.id}`,
                                              state: {
                                                id: sub_sub_category.id,
                                                name: sub_sub_category.name,
                                                page: 1,
                                              },
                                            }}
                                          >
                                            {sub_sub_category.name}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  </div>
                                  : <></>
                              ))}
                              <div className="col-md-2">
                                <img
                                  loading="lazy"
                                  src={category.image ? (`${process.env.REACT_APP_BASE_URL}${category.image}`) : "../../No-Image.png"}
                                  width="100%"
                                  alt={category.name}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-md-2">
                <div className="rightNumbs">
                  <a href="https://wa.me/+919872407145">
                    <i class="fa-brands fa-whatsapp"></i> +91 98724 07145
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal show={show} onHide={handleClose} className="mobileMenu">
          <i
            className="fa-solid fa-xmark CloseMenu"
            variant="secondary"
            onClick={handleClose}
          ></i>
          <div className="subMenu">
            <div className="toggleCategory">
              <div
                className={
                  selectedCategory === "Women" ? "sigtog active" : "sigtog"
                }
                onClick={(e) => updateSelectedCategory("Women")}
              >
                <img src={`${process.env.REACT_APP_BASE_URL}${womenTag}`} loading="lazy"></img>
                <button>Women</button>
              </div>
              <div
                className={
                  selectedCategory === "Men" ? "sigtog active" : "sigtog"
                }
                onClick={(e) => updateSelectedCategory("Men")}
              >
                <img src={`${process.env.REACT_APP_BASE_URL}${menTag}`} loading="lazy"></img>
                <button>Men</button>
              </div>
              <div
                className={
                  selectedCategory === "Kids" ? "sigtog active" : "sigtog"
                }
                onClick={(e) => updateSelectedCategory("Kids")}
              >
                <img src={`${process.env.REACT_APP_BASE_URL}${kidsTag}`} loading="lazy"></img>
                <button>Kids</button>
              </div>
            </div>
            <ul>
              <li>
                <Link to={{
                  pathname: "../../../../category/Bestseller",
                  state: {
                    id: 0,
                    name: "Bestseller",
                    page: 1,
                  },
                }} >Bestseller</Link>
              </li>
              {allCategories?.map((category, index) => {
                return (
                  <li key={index} className="menuDropDown">
                    <div className="singleNav">
                      <Link
                        onClick={handleClose}
                        to={{
                          pathname: `../../../../category/${category.name}/${category.id}`,
                          state: {
                            id: category.id,
                            name: category.name,
                            page: 1,
                          },
                        }}
                      >
                        {category.name}
                      </Link>
                      <i
                        className="fa-solid fa-angle-down"
                        onClick={() => handleToggle(index)}
                      ></i>
                    </div>
                    <div className={`subMenuMobile ${isToggled[index] ? "show" : ""}`}>
                      {category.subcategories?.map((sub_category, subIndex) => (
                        <div className="col-md-2" key={subIndex}>
                          <h2 className="collTitle">{sub_category.name}</h2>
                          <ul>
                            {sub_category.subcategories?.map((sub_sub_category, subSubIndex) => (
                              <li key={subSubIndex}>
                                <Link
                                  onClick={handleClose}
                                  to={{
                                    pathname: `../../../../category/${sub_sub_category.name}/${sub_sub_category.id}`,
                                    state: {
                                      id: sub_sub_category.id,
                                      name: sub_sub_category.name,
                                      page: 1,
                                    },
                                  }}
                                >
                                  {sub_sub_category.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </div>
                      ))}
                      {/* <div className="col-md-2">
              <img src={`${process.env.REACT_APP_BASE_URL}${category.image}`} width="100%" />
            </div> */}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default Header;
